
import styled from 'styled-components';
import modalTitle from '../../../element/ui/core/modal-title';

const StyledModalTitle = styled(modalTitle)`
  .SfxModalTitle-LabelPrimary {
    font-size: 14px;
    line-height: 16px;
    font-weight: 500;
  }
`;

export { StyledModalTitle };
